import { useQuery } from '@apollo/client/react'

import { graphql } from '~publish/graphql'

import type { OAuthScope } from './useOAuthScopes'

export const GetPersonalAccessTokenScopes = graphql(/* GraphQL */ `
  query getPersonalAccessTokenScopes {
    personalAccessTokenScopes(input: {}) {
      scopes {
        name
        group
        access
        description
        userFriendlyDescription
      }
    }
  }
`)

type UsePersonalAccessTokenScopesResult = {
  scopes: OAuthScope[]
  isLoading: boolean
  hasError: boolean
}

export const usePersonalAccessTokenScopes =
  (): UsePersonalAccessTokenScopesResult => {
    const { data, loading, error } = useQuery(GetPersonalAccessTokenScopes)

    return {
      scopes: data?.personalAccessTokenScopes?.scopes ?? [],
      isLoading: loading,
      hasError: !!error,
    }
  }
